module.exports = __webpack_public_path__ + "static/media/uni_logo.3e74e45d.svg";